import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);

export function utcToLocalDatetimeInput(isoString) {
    if (!isoString) return "";
    const d = dayjs.utc(isoString);
    if (!d.isValid()) return "";
    return d.local().format("YYYY-MM-DDTHH:mm");
}

export function localDatetimeInputToUtc(localString) {
    if (!localString) return "";
    const d = dayjs(localString);
    if (!d.isValid()) return "";
    return d.utc().format("YYYY-MM-DDTHH:mm");
}

export function nowUtcDatetimeInput() {
    return dayjs().utc().format("YYYY-MM-DDTHH:mm");
}

export function isValidDatetimeInput(value) {
    if (!value) return false;
    return dayjs(value).isValid();
}

export function isEndDateBeforeStartDate(startDate, endDate) {
    if (!isValidDatetimeInput(startDate) || !isValidDatetimeInput(endDate)) {
        return false;
    }
    return dayjs(endDate).isBefore(dayjs(startDate));
}

export function displayStartDateTime(isoString) {
    if (!isoString) return "";
    const d = dayjs(isoString);
    if (!d.isValid()) return "";
    return d.format("DD-MMM-YYYY, HH:mm A");
}
